import React, { useState, useEffect, useRef } from 'react';
import './SearchableSelect.css';

const SearchableSelect = ({ options, value, onChange, placeholder, label, name, addPath, addLabel }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredOptions, setFilteredOptions] = useState(options);
    const wrapperRef = useRef(null);

    useEffect(() => {
        setFilteredOptions(
            options.filter(option => {
                const searchStr = searchTerm.toLowerCase();
                const matchesName = (option.name || option).toLowerCase().includes(searchStr);
                const matchesSku = option.sku && option.sku.toLowerCase().includes(searchStr);
                return matchesName || matchesSku;
            })
        );
    }, [searchTerm, options]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);

    const handleSelect = (option) => {
        const val = option.name || option;
        onChange({ target: { name, value: val } });
        setSearchTerm('');
        setIsOpen(false);
    };

    return (
        <div className="searchable-select-wrapper" ref={wrapperRef}>
            {(label || addPath) && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                    {label && <p className="select-label" style={{ margin: 0 }}>{label}</p>}
                    {addPath && (
                        <a 
                            href={addPath} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="ss-add-new-link"
                        >
                            {addLabel || '+ New'}
                        </a>
                    )}
                </div>
            )}
            <div className={`select-control ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                <span className={!value ? 'placeholder' : ''}>
                    {value || placeholder || 'Select...'}
                </span>
                <span className="arrow">▼</span>
            </div>

            {isOpen && (
                <div className="select-dropdown">
                    <div className="ss-search-box">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                    <div className="options-list">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option, index) => (
                                <div
                                    key={index}
                                    className={`option-item ${value === (option.name || option) ? 'selected' : ''}`}
                                    onClick={() => handleSelect(option)}
                                >
                                    {option.sku ? `[${option.sku}] ` : ''}{option.name || option}
                                </div>
                            ))
                        ) : (
                            <div className="no-results">No results found</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchableSelect;
